/**
 * @author       luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  format params for listables query
 */
import type { ParamsType } from '../../types'

import { formatLeaseLength } from './formatLeaseLength'

export const LEASE_LENGTH_VALUES = {
  'A year or more': 'longTerm',
  '6-11 months': 'longTerm',
  '3-6 months': 'monthly',
  'Less than 3 months': 'vacation',
}

export const formatBedroomsList = (rooms: boolean[] = []) => {
  return rooms.reduce((accumulator: number[], currentVal: boolean, currentIndex: number) => {
    if (currentVal) {
      accumulator.push(currentIndex)
    }
    return accumulator
  }, [])
}

const formatPetsParams = (pets: string) => {
  if (pets === 'yes') {
    return { cats: true, dogs: true }
  }
}

export const formatAmenities = (amenities: string[]) => {
  const buildingAmenities: number[] = []
  const listingAmenities: number[] = []
  amenities.forEach((amenity) => {
    if (amenity.includes('b')) {
      buildingAmenities.push(Number.parseInt(amenity.substring(2)))
    }
    if (amenity.includes('l')) {
      listingAmenities.push(Number.parseInt(amenity.substring(2)))
    }
  })
  return {
    buildingAmenities,
    listingAmenities,
    allAmenities: buildingAmenities.concat(listingAmenities),
  }
}

export const formatParamsForListables = (params: ParamsType) => {
  const { finalPrice = 0, leaseLength, propertyCategories, finalAmenities } = params
  const bedrooms = formatBedroomsList(params?.bedrooms)
  const pets = formatPetsParams(params?.pets)
  const leaseLengthValue: string[] = [leaseLength[0]]
  const leaseLengthParams = formatLeaseLength(leaseLengthValue, LEASE_LENGTH_VALUES)
  const { buildingAmenities, listingAmenities } = formatAmenities(finalAmenities)

  return {
    buildingAmenities,
    bedrooms,
    limit: 10,
    listingAmenities,
    nearby: { threshold: 15 },
    maxPrice: finalPrice,
    minPrice: 0,
    ...pets,
    propertyCategories,
    url: '',
    ...leaseLengthParams,
    vacation: false,
    longTerm: false,
  }
}
